(function () {
  "use strict";

  function initComparisonSlider(container) {
    const resizeImg = container.querySelector(".resize img");
    const divider = container.querySelector(".divider");
    const resize = container.querySelector(".resize");
    if (!resizeImg || !divider || !resize) return;

    function setImageWidth() {
      resizeImg.style.width = container.offsetWidth + "px";
    }

    setImageWidth();

    let touched = false;
    window.addEventListener("touchstart", () => {
      touched = true;
    });
    window.addEventListener("touchend", () => {
      touched = false;
    });

    function onPointerDown(e) {
      if (e.type === "mousedown" && e.button !== 0) return;

      divider.classList.add("draggableeee");
      resize.classList.add("resizable");

      const pageX = e.pageX ?? e.touches?.[0]?.pageX;
      const dragWidth = divider.offsetWidth;
      const posX = divider.getBoundingClientRect().left + dragWidth - pageX;
      const containerRect = container.getBoundingClientRect();
      const minLeft = containerRect.left + 10;
      const maxLeft = containerRect.right - dragWidth - 10;

      function onMove(ev) {
        if (!touched) ev.preventDefault();
        const moveX = ev.pageX ?? ev.touches?.[0]?.pageX;
        let leftValue = moveX + posX - dragWidth;
        leftValue = Math.max(minLeft, Math.min(maxLeft, leftValue));
        const widthValue =
          ((leftValue + dragWidth / 2 - containerRect.left) * 100) /
            containerRect.width +
          "%";
        divider.style.left = widthValue;
        resize.style.width = widthValue;
      }

      function onEnd() {
        divider.classList.remove("draggableeee");
        resize.classList.remove("resizable");
        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("mouseup", onEnd);
        document.removeEventListener("touchmove", onMove);
        document.removeEventListener("touchend", onEnd);
        document.removeEventListener("touchcancel", onEnd);
      }

      document.addEventListener("mousemove", onMove);
      document.addEventListener("mouseup", onEnd);
      document.addEventListener("touchmove", onMove, { passive: false });
      document.addEventListener("touchend", onEnd);
      document.addEventListener("touchcancel", onEnd);
    }

    divider.addEventListener("mousedown", onPointerDown);
    divider.addEventListener("touchstart", onPointerDown, { passive: true });

    window.addEventListener("resize", setImageWidth);
  }

  window.theme = window.theme || {};
  theme.blueLightCompare = { init: initComparisonSlider };

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".comparison-slider").forEach(initComparisonSlider);
  });
})();
